import { injectable } from "tsyringe";
import { DistrictConfigurationInjection } from "../../di/DistrictConfigurationInjection";
import { DistrictConfigurationListRequestEntity } from "../entities/DistrictConfigurationListRequestEntity";
import { DistrictConfigurationFormRequestEntity } from "../entities/DistrictConfigurationFormRequestEntity";
import { ProvinceConfigurationInjection } from "features/provinceConfiguration/di/ProvinceConfigurationInjection";

@injectable()
export class DistrictConfigurationUseCase {
  private repo = DistrictConfigurationInjection.getRepo();

  private checkParams(params: DistrictConfigurationListRequestEntity) {
    const { page = 0, limit = 10, ...rest } = params;
    return { page, limit, ...rest };
  }

  async getDistrictConfigurationList(params: DistrictConfigurationListRequestEntity) {
    return this.repo.getList(this.checkParams(params));
  }

  async getDistrictConfigurationDetail(id: string) {
    return this.repo.getDetail({ id });
  }

  async createDistrictConfiguration(body: DistrictConfigurationFormRequestEntity) {
    return this.repo.create(body);
  }

  async updateDistrictConfiguration(body: DistrictConfigurationFormRequestEntity) {
    return this.repo.update(body);
  }

  async deleteDistrictConfiguration(id: string) {
    return this.repo.delete({ id });
  }

  async getProvinceList() {
    return ProvinceConfigurationInjection.getRepo().getList({
      page: 0,
      limit: 1000,
      order: "name ASC",
    });
  }
}
